import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Charsets_getInstance3jooo7e4x0j2x as Charsets_getInstance,
  get_name2f11g4r0d5pxp as get_name,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance27czzec4fvnke as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toList2zksu85ukrmi as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  Text_getInstancecnzpw4phsgym as Text_getInstance,
  charset1dribv3ku48b1 as charset,
  withCharset27k3t3dvzhi4n as withCharset,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  charset3qqtyytkmxogi as charset_0,
  contentType2zzm38yxo3syt as contentType,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { readText27783kyxjxi1g as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.nonJvm.mjs';
import { PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { readRemaining1kbpbgdrq25q1 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return LOGGER;
}
var LOGGER;
function get_HttpPlainText() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return HttpPlainText;
}
var HttpPlainText;
var HttpPlainTextConfigClass;
function HttpPlainTextConfig() {
  if (HttpPlainTextConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp.f5p_1 = LinkedHashSet().s2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.g5p_1 = LinkedHashMap().ec();
        this.h5p_1 = null;
        this.i5p_1 = Charsets_getInstance().e4m_1;
      }
    }
    initMetadataForClass($, 'HttpPlainTextConfig', HttpPlainTextConfig);
    HttpPlainTextConfigClass = $;
  }
  return HttpPlainTextConfigClass;
}
function RenderRequestHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, content, $completion) {
    var result = yield* $handler($this$intercept.w4s_1, content, $completion);
    var tmp;
    if (!(result == null)) {
      yield* $this$intercept.y4r(result, $completion);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 2);
}
var RenderRequestHookClass;
function RenderRequestHook() {
  if (RenderRequestHookClass === VOID) {
    class $ {
      j5p(client, handler) {
        var tmp = Phases_getInstance().j5m_1;
        client.e5g_1.a4t(tmp, RenderRequestHook$install$slambda(handler));
      }
      l5m(client, handler) {
        return this.j5p(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RenderRequestHook');
    RenderRequestHookClass = $;
  }
  return RenderRequestHookClass;
}
var RenderRequestHook_instance;
function RenderRequestHook_getInstance() {
  return RenderRequestHook_instance;
}
function HttpPlainTextConfig$_init_$ref_isjudo() {
  return constructCallableReference(() => new (HttpPlainTextConfig())(), 0, 0, 217, '<init>');
}
function HttpPlainText$lambda($this$createClientPlugin) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = toList($this$createClientPlugin.s5m_1.g5p_1);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = HttpPlainText$lambda$lambda;
  var tmp$ret$1 = new (sam$kotlin_Comparator$0())(tmp);
  var withQuality = sortedWith(this_0, tmp$ret$1);
  var responseCharsetFallback = $this$createClientPlugin.s5m_1.i5p_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$createClientPlugin.s5m_1.f5p_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (!$this$createClientPlugin.s5m_1.g5p_1.s4(element)) {
      destination.i2(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = HttpPlainText$lambda$lambda_0;
  var tmp$ret$6 = new (sam$kotlin_Comparator$0())(tmp_0);
  var withoutQuality = sortedWith(destination, tmp$ret$6);
  var tmp_1;
  var tmp0_0 = $this$createClientPlugin.s5m_1.f5p_1;
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_2;
    if (isInterface(tmp0_0, Collection())) {
      tmp_2 = tmp0_0.n1();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp$ret$7 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = tmp0_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (!element_0.equals(Charsets_getInstance().e4m_1)) {
        tmp$ret$7 = true;
        break $l$block_0;
      }
    }
    tmp$ret$7 = false;
  }
  if (tmp$ret$7) {
    tmp_1 = true;
  } else {
    var tmp0_1 = $this$createClientPlugin.s5m_1.g5p_1.v4();
    var tmp$ret$9;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_3;
      if (isInterface(tmp0_1, Collection())) {
        tmp_3 = tmp0_1.n1();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$9 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_1 = tmp0_1.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        if (!element_1.equals(Charsets_getInstance().e4m_1)) {
          tmp$ret$9 = true;
          break $l$block_2;
        }
      }
      tmp$ret$9 = false;
    }
    tmp_1 = tmp$ret$9;
  }
  var hasRegisteredCharsets = tmp_1;
  var tmp_4;
  if (hasRegisteredCharsets) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder().l1();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = withoutQuality.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var element_2 = _iterator__ex2g4s_2.r1();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.m1(',');
      }
      this_1.m1(get_name(element_2));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_3 = withQuality.p1();
    while (_iterator__ex2g4s_3.q1()) {
      var element_3 = _iterator__ex2g4s_3.r1();
      var charset = element_3.ze();
      var quality = element_3.af();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.m1(',');
      }
      // Inline function 'kotlin.check' call
      if (!(0.0 <= quality ? quality <= 1.0 : false)) {
        throw IllegalStateException().o('Check failed.');
      }
      // Inline function 'kotlin.math.roundToInt' call
      var this_2 = 100 * quality;
      var truncatedQuality = roundToInt(this_2) / 100.0;
      this_1.m1(get_name(charset) + ';q=' + truncatedQuality);
    }
    tmp_4 = this_1.toString();
  } else {
    tmp_4 = null;
  }
  var acceptCharsetHeader = tmp_4;
  var tmp0_elvis_lhs = $this$createClientPlugin.s5m_1.h5p_1;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(withoutQuality) : tmp0_elvis_lhs;
  var tmp_5;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = firstOrNull(withQuality);
    tmp_5 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.xe_1;
  } else {
    tmp_5 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_5;
  var requestCharset = tmp3_elvis_lhs == null ? Charsets_getInstance().e4m_1 : tmp3_elvis_lhs;
  var tmp_6 = RenderRequestHook_instance;
  $this$createClientPlugin.v5m(tmp_6, HttpPlainText$lambda$slambda(acceptCharsetHeader, requestCharset));
  $this$createClientPlugin.k5p(HttpPlainText$lambda$slambda_0(responseCharsetFallback));
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.l5p_1 = function_0;
      }
      ih(a, b) {
        return this.l5p_1(a, b);
      }
      compare(a, b) {
        return this.ih(a, b);
      }
      i5() {
        return this.l5p_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function HttpPlainText$lambda$lambda(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.ye_1;
  var tmp$ret$2 = a.ye_1;
  return compareValues(tmp, tmp$ret$2);
}
function HttpPlainText$lambda$lambda_0(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_name(a);
  var tmp$ret$2 = get_name(b);
  return compareValues(tmp, tmp$ret$2);
}
function invoke$wrapContent(requestCharset, request, content, requestContentType) {
  var contentType = requestContentType == null ? Text_getInstance().j4w_1 : requestContentType;
  var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
  var charset_0 = tmp2_elvis_lhs == null ? requestCharset : tmp2_elvis_lhs;
  get_LOGGER().a4u('Sending request body to ' + request.y5h_1.toString() + ' as text/plain with charset ' + charset_0.toString());
  return new (TextContent())(content, withCharset(contentType, charset_0));
}
function invoke$read(responseCharsetFallback, call, body) {
  var tmp0_elvis_lhs = charset_0(call.r5g());
  var actualCharset = tmp0_elvis_lhs == null ? responseCharsetFallback : tmp0_elvis_lhs;
  get_LOGGER().a4u('Reading response body for ' + call.p5i().y5i().toString() + ' as String with charset ' + actualCharset.toString());
  return readText(body, actualCharset);
}
function invoke$addAcceptCharsetHeader(_this__u8e3s4, value) {
  if (value == null || !(_this__u8e3s4.a5i_1.c2o('Accept-Charset') == null))
    return Unit_instance;
  get_LOGGER().a4u('Adding Accept-Charset=' + value + ' to ' + _this__u8e3s4.y5h_1.toString());
  _this__u8e3s4.a5i_1.u4p('Accept-Charset', value);
}
function HttpPlainText$lambda$slambda($acceptCharsetHeader, $requestCharset) {
  return constructCallableReference(function *(request, content, $completion) {
    invoke$addAcceptCharsetHeader(request, $acceptCharsetHeader);
    var tmp;
    if (!(typeof content === 'string')) {
      return null;
    }
    var contentType_0 = contentType(request);
    var tmp_0;
    if (!(contentType_0 == null) && !(contentType_0.q4u_1 === Text_getInstance().j4w_1.q4u_1)) {
      return null;
    }
    return invoke$wrapContent($requestCharset, request, content, contentType_0);
  }, 2);
}
function HttpPlainText$lambda$slambda_0($responseCharsetFallback) {
  return constructCallableReference(function *($this$transformResponseBody, response, content, requestedType, $completion) {
    var tmp;
    if (!requestedType.o4t_1.equals(PrimitiveClasses_getInstance().cg())) {
      return null;
    }
    var bodyBytes = yield* readRemaining(content, $completion);
    return invoke$read($responseCharsetFallback, response.w5i(), bodyBytes);
  }, 4);
}
var properties_initialized_HttpPlainText_kt_2nx4ox;
function _init_properties_HttpPlainText_kt__iy89z1() {
  if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
    properties_initialized_HttpPlainText_kt_2nx4ox = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    var tmp = HttpPlainTextConfig$_init_$ref_isjudo();
    HttpPlainText = createClientPlugin('HttpPlainText', tmp, HttpPlainText$lambda);
  }
}
//region block: init
RenderRequestHook_instance = new (RenderRequestHook())();
//endregion
//region block: exports
export {
  get_HttpPlainText as get_HttpPlainText2hd9sygnz4kij,
};
//endregion

//# sourceMappingURL=HttpPlainText.mjs.map
